import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FixedPluginComponent } from './fixedplugin.component';

@NgModule({
  imports: [RouterModule, CommonModule, FormsModule],
  declarations: [FixedPluginComponent],
  exports: [FixedPluginComponent]
})
export class FixedPluginModule {}
